<template>
  <Modal ref="modal" class="modal-user-delete" :actions="actions" @action="handleAction" immediate>
    <h1>Benutzer löschen</h1>
    <p>Wollen Sie den Benutzer wirklich löschen?<br/>
      Dieser Benutzer wird unwiderruflich gelöscht.</p>
    <div class="warn" v-if="inquiries > 0">
      <Icon name="alert" />
      Dieser Benutzer hat noch Fälle zugewiesen.<br/>
      Bitte teilen Sie diese zuerst um.
    </div>
  </Modal>
</template>

<script>
  import Modal from '@/components/ui/Modal';
  import Select from '@/components/ui/inputs/Select';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'ModalUserDelete',
    components: {
      Icon,
      Select,
      Modal,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      uuid: {
        type: String,
        default: null,
      },
      inquiries: {
        type: Number,
        default: 0,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      actions() {
        const i18n = this.$i18n;
        return [
          { value: 'cancel', label: i18n.t('labels.cancel') },
          { value: 'delete', label: i18n.t('labels.delete'), disabled: this.inquiries > 0 },
        ];
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // async created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      async handleAction(action) {
        if (action === 'delete') {
          const uuid = this.uuid;
          const response = await this.$sav.api.delete(`/user/${uuid}`);
          if (response) {
            this.$emit('done');
          }
        }
        this.$refs.modal.close();
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.modal-user-delete {
  h1 {
    margin-bottom: 12px;
  }

  p {
    @include font-body-medium;
    color: $color-black-solid-100;
  }

  div.warn {
    position: relative;
    padding: 8px 8px 8px 42px;
    border: 1px solid $color-signal-red;
    border-radius: 4px;
    box-shadow: $box-shadow-1;
    color: $color-signal-red;
    svg {
      top: 50%;
      left: 8px;
      transform: translate(0, -50%);
      position: absolute;
      width: 20px;
      height: 20px;
    }
  }

  form {
    padding: 24px 0;

    .group {
      margin-bottom: 24px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }

    hr {
      border: 0;
      margin: 24px 0;
      border-bottom: 1px solid $color-black-alpha-10;
    }
  }
}
</style>
